import Component from '@glimmer/component';

interface IArgs {}

export default class UnsavedFlash extends Component<IArgs> {}
